import { render, staticRenderFns } from "./detailTitleCon.vue?vue&type=template&id=cebdd2cc"
import script from "./detailTitleCon.vue?vue&type=script&lang=js"
export * from "./detailTitleCon.vue?vue&type=script&lang=js"
import style0 from "./detailTitleCon.vue?vue&type=style&index=0&id=cebdd2cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports